var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-alert",
        {
          directives: [
            { name: "show", rawName: "v-show", value: true, expression: "true" }
          ],
          attrs: { color: "primary", value: "true", outline: "" }
        },
        [_vm._v("\n      " + _vm._s(_vm.$t("smsWarning")) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "v-alert",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.alert,
              expression: "alert"
            }
          ],
          attrs: {
            color: "secondary",
            icon: "warning",
            value: "true",
            outline: ""
          }
        },
        [_vm._v("\n     " + _vm._s(_vm.$t("smsWarning2")) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.loadingGet
            ? _c(
                "div",
                { staticClass: "text-xs-center" },
                [
                  _c("v-progress-circular", {
                    staticClass: "primary--text",
                    attrs: { indeterminate: "", size: 100, width: 1 }
                  })
                ],
                1
              )
            : _c(
                "v-card",
                { staticClass: "mb-3" },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.onOff ? "SMS ON" : "SMS OFF",
                                  light: "",
                                  color: "primary"
                                },
                                model: {
                                  value: _vm.onOff,
                                  callback: function($$v) {
                                    _vm.onOff = $$v
                                  },
                                  expression: "onOff"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.$t("smsNumb"),
                                  required: "",
                                  "data-vv-name": "numSMS"
                                },
                                model: {
                                  value: _vm.numero,
                                  callback: function($$v) {
                                    _vm.numero = $$v
                                  },
                                  expression: "numero"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.c2c
                                    ? _vm.$t("smsCallb") + " ON"
                                    : _vm.$t("smsCallb") + " OFF",
                                  light: "",
                                  color: "primary"
                                },
                                model: {
                                  value: _vm.c2c,
                                  callback: function($$v) {
                                    _vm.c2c = $$v
                                  },
                                  expression: "c2c"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.c2c_missed
                                    ? _vm.$t("smsCallb2") + " ON"
                                    : _vm.$t("smsCallb2") + " OFF",
                                  light: "",
                                  color: "primary"
                                },
                                model: {
                                  value: _vm.c2c_missed,
                                  callback: function($$v) {
                                    _vm.c2c_missed = $$v
                                  },
                                  expression: "c2c_missed"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.chat
                                    ? _vm.$t("smsChat") + " ON"
                                    : _vm.$t("smsChat") + " OFF",
                                  light: "",
                                  color: "primary"
                                },
                                model: {
                                  value: _vm.chat,
                                  callback: function($$v) {
                                    _vm.chat = $$v
                                  },
                                  expression: "chat"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.abs
                                    ? _vm.$t("smsAbs") + " ON"
                                    : _vm.$t("smsAbs") + " OFF",
                                  light: "",
                                  color: "primary"
                                },
                                model: {
                                  value: _vm.abs,
                                  callback: function($$v) {
                                    _vm.abs = $$v
                                  },
                                  expression: "abs"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.messagin
                                    ? _vm.$t("smsMessagin") + " ON"
                                    : _vm.$t("smsMessagin") + " OFF",
                                  light: "",
                                  color: "primary"
                                },
                                model: {
                                  value: _vm.messagin,
                                  callback: function($$v) {
                                    _vm.messagin = $$v
                                  },
                                  expression: "messagin"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-xs-right" },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    block: _vm.$vuetify.breakpoint.xsOnly,
                    loading: _vm.loadingPost,
                    disabled: _vm.alert
                  },
                  nativeOn: {
                    click: function($event) {
                      return _vm.postOptions()
                    }
                  }
                },
                [
                  _vm._v(_vm._s(_vm._f("cap")(_vm.$t("save")))),
                  _c("v-icon", { attrs: { dark: "", right: "" } }, [
                    _vm._v("save")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-84731246", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84731246","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/Sms.vue
// module id = null
// module chunks = 